import { createApp, defineCustomElement } from 'vue';
import FloatingPlayer, { movePlayers } from '@scripts/floating-player.js';
import useMobileMenu from '@scripts/mobileMenu.js';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupFormsPlugin from '@swup/forms-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Swup from 'swup';

import '@styles/app.css';

const menu = useMobileMenu()

const swup = new Swup({
    animationSelector: false,
    containers: ['#app'],
    cache: false,
    native: false,
    plugins: [
        new SwupBodyClassPlugin(),
        new SwupHeadPlugin({
            persistAssets: true,
            attributes: ['class'],
        }),
        new SwupFormsPlugin({
            stripEmptyParams: true,
        }),
    ],
    hooks: {
        'visit:start': () => {
            menu.close()
        },
        'content:replace.before': async (visit) => {
            await movePlayers(visit)
        },
        'content:replace': (e) => {
            menu.init()

            e.meta?.callback?.()
        },
    },
})

window.swup = swup
window.floatingPlayers = {}

const floatingPlayerElements = document.querySelectorAll(
    '#keepalive > .keepalive'
) as NodeListOf<HTMLElement>

floatingPlayerElements.forEach((floatingPlayerElement) => {
    const player = new FloatingPlayer(floatingPlayerElement)
    window.floatingPlayers[player.id] = player
})

const app = createApp({
    compilerOptions: {
        // web components that are used in twig templates
        isCustomElement: (tag) => tag.startsWith('jp-'),
    },
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.mount('#app')
app.use(pinia)

const components: Record<string, any> = import.meta.glob(
    '@components/**/*.vue',
    {
        eager: true,
    }
)

Object.entries(components).forEach(([path, definition]) => {
    const componentName = path
        .split('/')
        .pop()
        ?.replace(/\.\w+$/, '')

    if (!componentName || !componentName.startsWith('Jp')) return

    const tagName = componentName
        .replace(/([a-z0–9])([A-Z])/g, '$1-$2')
        .toLowerCase()

    const element = defineCustomElement(definition.default, {
        shadowRoot: false,
    })

    customElements.define(tagName, element)
})
